import { Component, Inject, Directive, ElementRef, AfterViewInit, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { ApisService } from 'src/app/services/apis.service';
import { environment } from 'src/environments/environment';
import { Meta, Title } from '@angular/platform-browser';
import { isPlatformBrowser, DOCUMENT } from '@angular/common';
import { REQUEST } from '@nguniversal/express-engine/tokens';
import { Injector } from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { MetafieldsService } from 'src/app/services/metafields.service';

declare var Zone: any;
// declare var $: any;

@Component({
  selector: 'app-blog-detail-view',
  templateUrl: './blog-detail-view.component.html',
  styleUrls: ['./blog-detail-view.component.scss'],

})

export class BlogDetailViewComponent implements OnInit, OnDestroy {
  schema: any;
  BlogData: any;
  subscription: any;
  previous: any;
  next: any;
  url: any;
  authid: any;
  blogid: any;
  randimage: any = [];
  randomimage: any = [];
  filterdata: any;
  stylesdeveloper: any = [
    {
      id: "removethisdevelop",
      href: "assets/css/css-main/developer_custom.css",
      rel: "stylesheet",
      elementType: "link"
    }
  ]

  constructor(
    @Inject(DOCUMENT) private dom: any,

    private el: ElementRef,
    @Inject(DOCUMENT) private document: Document,

    private apisService: ApisService,
    private meta: Meta,
    private router: Router,
    private titleSer: Title,
    @Inject(PLATFORM_ID) private platformId: any,
    private _injector: Injector,
    private metablogs: MetafieldsService
  ) {

    this.randomimage = ["https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQhkFGT0HnLnDXi3aNx1C2HqeJUhJzlOGyTgA&usqp=CAU=",
      "https://vidhema-website.s3.amazonaws.com/Vidhema/VidhemaBlogImages/202316142631-433backimage.png", "https://vidhema-website.s3.amazonaws.com/Vidhema/VidhemaBlogImages/202316142541-567bg-1.jpg"]
    this.randimage = this.randomimage[Math.floor(Math.random() * this.randomimage.length)]
    console.log(this.randimage, 'this.randimage')

  }

  formateDate(date: any) {
    var newDate = new Date(date);
    const monthNames = ["January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];
    return monthNames[newDate.getMonth()] + ', ' + ("0" + newDate.getDate()).slice(-2) + ' ' + newDate.getFullYear()
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.stylesdeveloper.map((element: any) => {
      this.metablogs.removeLink("#removethisdevelop");
    });

  }

  ngOnInit(): void {
    this.subscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        let url = "";
        if (isPlatformBrowser(this.platformId)) {
          window.scrollTo({
            top: 0,
            behavior: 'smooth',
          })
          url = new URL(location.href).pathname
        } else {
          let req = this._injector.get(REQUEST);
          url = req.url;
        }
        this.getApiData(url);
      }
    })
    let url = "";
    if (isPlatformBrowser(this.platformId)) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
      url = new URL(location.href).pathname
    } else {
      let req = this._injector.get(REQUEST);
      url = req.url;
    }
    this.getApiData(url);
    this.stylesdeveloper.map((element: any) => {
      this.metablogs.addLink(element, element.elementType);
    })

    let category:any = 'All';
    var  filter ={
      include:['authorId','categoryids'],
      "where":{
        "status":true,
        "categoryids":category == "All" ? undefined:category,
        "date":{$lte:new Date()}
      },
     
      "limit":3,
      
      "fields":["title","shortDescription","url","date","featured_image","authorId","categoryids"],
      "order": {"date":-1}
    }
    this.filterdata=[]
    this.apisService.getAllWithQuerywihName(environment.apis.blogs,filter).then((res:any)=>{
      if(res.length > 0){
        this.filterdata = res;
        console.log(this.filterdata,"blog listing", this.BlogData, "blog data")
        console.log(this.filterdata,'Blogs')
        this.filterdata = this.filterdata.filter(blog => blog._id !== this.BlogData._id);
      }else{
        this.router.navigateByUrl('/notfound');
      }
    })


  }
  trimString(string: any, length: any) {
    return string.length > length
      ? string.substring(0, length) + '...'
      : string;
  }
  getApiData(url: any) {
    var filter = {
      "where": {
        "status": true,
        "url": url
      },
      "limit": 1,
    }
    this.apisService.getAllWithQuerywihName(environment.apis.blogs, filter).then((res: any) => {
      if (res[0]) {

        this.BlogData = res[0];
        console.log(this.BlogData, 'blogd')
        console.log(this.BlogData.description)
        this.previousdata();
        this.nextdata();

        this.titleSer.setTitle(this.BlogData.title + ' | Vidhema Technologies')
        this.meta.updateTag({ name: 'name', content: this.BlogData.title + ' | Vidhema Technologies' });
        this.meta.updateTag({ name: 'description', content: this.BlogData.metatags.description });
        this.meta.updateTag({ name: 'keywords', content: this.BlogData.metatags.Keyword })

        this.meta.updateTag({ property: "og:url", content: 'https://vidhema.com' + this.BlogData.url })
        this.meta.updateTag({ property: "og:title", content: this.BlogData.title + ' | Vidhema Technologies' })
        this.meta.updateTag({ property: "og:site_name", content: this.BlogData.title + ' | Vidhema Technologies' })
        this.meta.updateTag({ property: "og:description", content: this.BlogData.metatags.description })
        this.meta.updateTag({ property: 'og:type', content: "website" })
        this.meta.updateTag({ property: "og:image", content: this.BlogData.metatags.imgUrl })

        this.meta.updateTag({ name: 'twitter:card', content: "summary_large_image" })
        this.meta.updateTag({ name: "twitter:url", content: 'https://vidhema.com' + this.BlogData.url })
        this.meta.updateTag({ name: "twitter:creator", content: '@Videhma' })
        this.meta.updateTag({ name: "twitter:title", content: this.BlogData.title + ' | Vidhema Technologies' })
        this.meta.updateTag({ name: "twitter:description", content: this.BlogData.metatags.description })
        this.meta.updateTag({ name: "twitter:image", content: this.BlogData.metatags.imgUrl })



        console.log(this.BlogData, 'blogefdfdfrererss')
        const link: HTMLLinkElement = this.dom.createElement('script');
        link.setAttribute("type", "application/ld+json");
        link.innerHTML = JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BlogPosting",
          "mainEntityOfPage": {
            "@type": "WebPage",
            "@id": this.BlogData?.featured_image
          },
          "headline": this.BlogData?.title,
          "description": this.BlogData.shortDescription,
          "image": this.BlogData?.featured_image,
          "author": {
            "@type": "Person",
            "name": this.BlogData?.author?.name
          },
          "publisher": {
            "@type": "Organization",
            "name": "Vidhema Technologies",
            "logo": {
              "@type": "ImageObject",
              "url": "https://vidhema-website.s3.amazonaws.com/home-new/image/about/vidhema-logo-black.png"
            }
          },
          "datePublished": this.formateDate(this.BlogData?.date)


        });
        console.log("link", link)
        this.dom.head.appendChild(link);



// =======blog script

const link1: HTMLLinkElement = this.dom.createElement('script');
link1.setAttribute("type", "application/ld+json");
link1.innerHTML = JSON.stringify({
  "@context": "https://schema.org",
  "@type": "BlogPosting",
  "mainEntityOfPage": {
    "@type": "WebPage",
    "@id": this.BlogData?.url
  },
  "headline": this.BlogData?.title,
  "description": this.BlogData.shortDescription,
  "image": this.BlogData?.backgroundImage,
  "author": {
    "@type": "Person",
    "name": this.BlogData?.author?.name
  },
  "publisher": {
    "@type": "Organization",
    "name": "Vidhema Technologies",
    "logo": {
      "@type": "ImageObject",
      "url": "https://vidhema-website.s3.amazonaws.com/home-new/image/about/vidhema-logo-black.png"
    }
  },
  "datePublished": this.formateDate(this.BlogData?.date)


});
console.log("link1", link1)
this.dom.head.appendChild(link1);







        if(this.BlogData?.otherDetails){
          this.BlogData?.otherDetails.map((res:any)=>{
            const link2: HTMLLinkElement = this.dom.createElement('script');
            link2.setAttribute("type", "application/ld+json");
            link2.innerHTML = JSON.stringify({
              "@context1": "https://schema.org",
              "@type1": "FAQPage",
              "mainEntity": [{
                "@type": "Question",
                "name": res.faq,
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": res.answer
                }
              }]
            })
            this.dom.head.appendChild(link2);
  
          })
         
        }
        

        this.apisService.getAllWithQuerywihName(environment.apis.AUTHOR, { "where": { _id: res[0].authorId } }).then((res: any) => {
          this.BlogData.author = res[0];

        })
        this.apisService.getAllWithQuerywihName(environment.apis.CATEGORY, { "where": { _id: { "$in": res[0].categoryids } } }).then((res: any) => {
          this.BlogData.categories = res;
          console.log(this.BlogData.categories, 'getapi')

        })

      } else {
        this.router.navigateByUrl('/notfound');
      }
    })
  }


  openSocial(type: any) {
    let openurl = "";
    if (type == "linkedin") {
      openurl = 'https://www.linkedin.com/shareArticle?url=@u'
    } else if (type == "facebook") {
      openurl = 'https://www.facebook.com/people/Vidhema-Technologies/100063487553669?u=@u&title=@t&description=@d'
    } else if (type == "skype") {
      openurl = 'https://web.skype.com/share?url=@u%0D%0A&text=@t%0D%0A'
    } else if (type == "whatsapp") {
      openurl = 'https://api.whatsapp.com/send?text=@t%0D%0A@u%0D%0A@d'
    } else if (type == "twitter") {
      openurl = 'https://twitter.com/intent/tweet?text=@t&url=@u'
    }
    console.log(openurl,'openurl')

    openurl = openurl
      .replace(/@u/g, encodeURIComponent('https://vidhema.com' + this.BlogData.url))
      .replace(/@t/g, encodeURIComponent(this.BlogData.title))
      .replace(/@d/g, encodeURIComponent(this.BlogData.shortDescription))

    setTimeout(() => {
      window.open(openurl, '_blank');
    }, 200);

  }
  previousdata() {
    this.previous = []
    var filter = {
      "where": {
        "authorId": this.BlogData.authorId,
        "_id": { "$lt": this.BlogData._id }
      },
      "limit": 1,
      "fields": ["url"]

    }
    this.apisService.getAllWithQuerywihName(environment.apis.blogs, filter).then((res: any) => {
      // this.  = res;
      if (res) {
        console.log(res, 'resp ')
        this.previous = res[0];
      }
      console.log(this.previous, 'this.previous');

    })
  }
  nextdata() {
    this.next = [];
    var filter1 = {
      "where": {
        "authorId": this.BlogData.authorId,
        "_id": { "$gt": this.BlogData._id },
      },
      "limit": 1,
      "fields": ["url"]
    }
    this.apisService.getAllWithQuerywihName(environment.apis.blogs, filter1).then((res: any) => {
      if (res) {
        this.next = res[0];
      }
    })

  }
  authblogpre() {


    this.router.navigate([this.previous.url])
  }
  authblognex() {
    this.router.navigate([this.next.url])


  }



}
function dateFormat(date: any, arg1: string) {
  throw new Error('Function not implemented.');
}

